<template>
    <div>
        <div v-if="type === 'sign'" role="dialog" id="sign" class="modal fade g-modal" active="false" data-backdrop="static">
            <div role="document" class="modal-dialog modal-dialog-centered">
                <div class="modal-content">

                    <!-- SIGNHEADER -->
                    <SignHeader :closeCallback="abortSigning"></SignHeader>

                    <!-- SIGNSTRIPE -->
                    <SignStripe :signData="signData"></SignStripe>

                    <!-- TABS -->
                    <div v-if="!isMethodFamily('NONE') && !submitingAuthKey">
                        <ul class="tabs nav nav-tabs pb-0 br mt-3">
                            <li v-for="(_method, idx) in requestedAuthMethods" :key="idx" class="nav-item pb-0">
                                <a class="nav-link focusable in-modal" :class="{active: (isMethodFamily(requestedAuthMethods[idx][0]))}" :id="requestedAuthMethods[idx][0]" href="javascript:;"
                                v-on:click="changeMethod(`${requestedAuthMethods[idx][0]}$`)">{{ $t(`sign.methods.${requestedAuthMethods[idx][0]}`) }}</a>
                            </li>
                        </ul>
                        <br aria-hidden="true" />
                    </div>

                    <div v-else style="margin-top:1em"></div>

                    <!-- SMSINP -->
                    <div v-if="isMethodFamily('SMS') && !submitingAuthKey">
                        <div v-if="toolGenerated['SMS']">
                            <p class="text-center p-dyn keyMsg">{{ $helpers.parse($t("sign.smsKeyAck"), smsData.phoneNumber, smsData.smsId, timeService.timer) }}</p>
                            <div class="modal-footer g-modal-footer-grey mt-3 greybar">
                                <label class="mb-0" for="text4697">{{ $t("sign.smsLabel") }}</label>
                                <input type="text" aria-describedby="TAC" v-model="values.SMS" style="max-width:115px;margin:0 10px"
                                    id="text4697" placeholder="****" class="form-control" @focus="handleFocus(1)" @blur="handleFocus(!1)" v-on:keydown.enter="tryToSubmit()" autocomplete="off" autoFocus>
                                <button type="button" class="btn g-btn-primary" @click="submitAuthKey()">
                                    <span>{{ $t("sign.submit") }}</span>
                                </button>
                            </div>
                        </div>
                        <div v-else class="container mw-100 mb-3">
                            <p class="text-center">{{ $t("sign.smsSendLabel") }}</p>
                            <div class="text-center">
                                <button type="button" class="btn g-btn-primary mt-3" @click="changeMethod('SMS')">
                                    <span>{{ $t("sign.sendSms") }}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- MTOKENINP -->
                    <div v-show="isMethodFamily('CASE_MOBILE') && !submitingAuthKey" class="mToken-signbar">

                        <div v-if="toolGenerated['CASE_MOBILE']" class="mb-2">
                            <div class="text-center p-dyn keyMsg">

                                <span>{{ $t('sign.mTokenAck') }}</span>

                                <div v-if="!$helpers.isMobile()">
                                    <span> {{ $t('sign.mTokenAckNoPhone1') }}</span>
                                    <a @click.prevent="showQrCode"> {{ $t('sign.mTokenAckNoPhone2') }}</a>
                                </div>

                                <div v-show="mTokenData.qrShown && !$helpers.isMobile()" class="qr-container">
                                    <canvas width="250" height="250" id="qrCode"></canvas>
                                </div>

                                <div v-show="mTokenData.qrShown && !$helpers.isMobile()" class="modal-footer g-modal-footer-grey mt-3 greybar">
                                    <p>{{ $t("sign.mTokenLabel") }}</p>
                                    <input type="text" aria-describedby="TAC" v-model="values.CASE_MOBILE" style="max-width:115px;margin:0 10px"
                                        id="text4697" :placeholder="mTokenData.placeholder" class="form-control" @focus="handleFocus(1)" @blur="handleFocus(!1)" v-on:keydown.enter="tryToSubmit()" autocomplete="off" autofocus>
                                    <button type="button" class="btn g-btn-primary" @click="submitAuthKey()">
                                        <span>{{ $t("sign.submit") }}</span>
                                    </button>
                                </div>

                            </div>
                        </div>
                        <div v-else class="container mw-100 mb-3">
                            <p class="text-center">{{ $t("sign.useMtokenLabel") }}</p>
                            <div class="text-center">
                                <button type="button" class="btn g-btn-primary mt-3" @click="changeMethod('CASE_MOBILE')">
                                    <span>{{ $t("sign.useMtoken") }}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-show="isMethodFamily('GEORGE_TOKEN') && !submitingAuthKey" class="mToken-signbar">

                        <div v-if="toolGenerated['GEORGE_TOKEN']" class="mb-2">
                            <div class="text-center p-dyn keyMsg">

                                <span>{{ $t('sign.georgeIdAck') }}</span>

                            </div>
                        </div>
                        <div v-else class="container mw-100 mb-3">
                            <p class="text-center">{{ $t("sign.useGeorgeLabel") }}</p>
                            <div class="text-center">
                                <button type="button" class="btn g-btn-primary mt-3" @click="changeMethod('GEORGE_TOKEN')">
                                    <span>{{ $t("sign.useGeorge") }}</span>
                                </button>
                            </div>
                        </div>
                    </div>


                    <!-- GRIDINP -->
                    <div v-if="isMethodFamily('GRID_CARD') && !submitingAuthKey">
                        <div v-if="toolGenerated['GRID_CARD']" >
                            <p class="text-center">{{ $t("sign.gridKeyAck") }}</p>
                            <div class="modal-footer g-modal-footer-grey mt-3 greybar">
                                <label class="mb-0" for="text4697">{{ $t("sign.gridLabel") }}</label>
                                <input type="text" aria-describedby="TAC" v-model="values.GRID_CARD" style="max-width:115px;margin:0 10px"
                                    id="text4697" :placeholder="gridData.placeholder" class="form-control" @focus="handleFocus(1)" @blur="handleFocus(!1)" v-on:keydown.enter="tryToSubmit()" autocomplete="off" autofocus>
                                <button type="button" class="btn g-btn-primary" @click="submitAuthKey()">
                                    <span>{{ $t("sign.submit") }}</span>
                                </button>
                            </div>
                        </div>
                        <div v-else class="container mb-3">
                            <p class="text-center"> {{ $t("sign.gridGenLabel") }}</p>
                            <div class="text-center">
                                <button type="button" class="btn g-btn-primary mt-3" @click="changeMethod('GRID_CARD')">
                                    <span>{{ $t("sign.genGrid") }}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- NONEINP -->
                    <div v-if="isMethodFamily('NONE') && !submitingAuthKey" class="mb-1">
                        <div class="container">
                            <p class="text-center"> {{ $t("sign.noneLabel") }}</p>
                            <div class="text-center mb-1">
                                <button type="button" class="btn g-btn-primary mt-3" @click="submitAuthKey()">
                                    <span>{{ $t("sign.sendNone") }}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- PROCESSACK -->
                    <div v-if="submitingAuthKey">
                        <div class="text-center pb-2 pr-2 pl-2">
                            <h3>{{ $t("sign.processText") }}</h3>
                        </div>
                    </div>

                    <!-- ERRORMSG -->
                    <div v-if="errorMsg[noPseudo(method)]" class="text-center" aria-live="assertive">
                        <div class="card g-card g-card-alert-error mt-2 mb-1" style="width:90%">
                            <div class="card-block pt-1 pb-1 pl-2 pr-2">
                                <svg class="ico-exclamation-triangle" aria-hidden="true" focusable="false">
                                    <use href="#ico-exclamation-triangle" xlink:href="#ico-exclamation-triangle" />
                                </svg>
                                <div class="g-card-alert-data">
                                    <p>{{ errorMsg[noPseudo(method)] }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- SIGNINFO -->
                    <div v-if="toolGenerated[noPseudo(method)] && !submitingAuthKey && !isMethodFamily('CASE_MOBILE')" class="text-center g-faded p-dyn pt-1 pb-1">
                        <p>{{ $t("sign.info") }}</p>
                    </div>

                    <!-- HINTBAR -->
                    <div class="pl-3 pr-3 pb-3 pt-1 mt-0">
                        <div class="card g-card g-card-alert-info">
                            <div class="card-block">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" focusable="false" :title="$t('icon.warning')">
                                    <defs>
                                        <path id="info_icon_blue-a" d="M8,0.642466667 C12.0481898,0.642466667 15.3333333,3.92761017 15.3333333,7.9758 C15.3333333,12.0244366 12.0484097,15.3091333 8,15.3091333 C3.95159025,15.3091333 0.666666667,12.0244366 0.666666667,7.9758 C0.666666667,3.92761017 3.95181017,0.642466667 8,0.642466667 Z M8,1.9758 C4.68818983,1.9758 2,4.66398983 2,7.9758 C2,11.2880363 4.68794931,13.9758 8,13.9758 C11.3120507,13.9758 14,11.2880363 14,7.9758 C14,4.66398983 11.3118102,1.9758 8,1.9758 Z M7.33333333,7.30913333 C7.33333333,6.9409435 7.63181017,6.64246667 8,6.64246667 C8.36818983,6.64246667 8.66666667,6.9409435 8.66666667,7.30913333 L8.66666667,11.3091333 C8.66666667,11.6773232 8.36818983,11.9758 8,11.9758 C7.63181017,11.9758 7.33333333,11.6773232 7.33333333,11.3091333 L7.33333333,7.30913333 Z M8,5.3072 C7.632,5.3072 7.33333333,5.00853333 7.33333333,4.64053333 C7.33333333,4.27186667 7.632,3.97386667 8,3.97386667 C8.368,3.97386667 8.66666667,4.27186667 8.66666667,4.64053333 C8.66666667,5.00853333 8.368,5.3072 8,5.3072 Z"/>
                                    </defs>
                                    <use fill="#005480" xlink:href="#info_icon_blue-a"/>
                                </svg>

                                <div class="g-card-alert-data">
                                    <span v-html="$t('sign.hint')"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { store } from '../../store/store';
    import SignStripe from '../elements/SignStripe.vue';
    import SignHeader from '../elements/SignHeader.vue';

    export default {

        name: 'Signscreen',

        data() {
            return {
                method: '',
                toolGenerated: {
                    SMS: false,
                    GRID_CARD: false,
                    CASE_MOBILE: false,
                    GEORGE_TOKEN: false,
                },
                smsData: {
                    smsId: '',
                    phoneNumber: '',
                },
                gridData: {
                    placeholder: this.$t('sign.methods.gridPlaceholder'),
                },
                mTokenData: {
                    challengeImage: '',
                    image: null,
                    qrShown: false,
                    placeholder: this.$t('sign.methods.mTokenPlaceholder'),
                },
                values: {
                    GRID_CARD: '',
                    CASE_MOBILE: '',
                    SMS: '',
                    NONE: '14',
                },
                timeService: {
                    clock: null,
                    timer: -.5,
                },
                errorMsg: {},
                signId: '',
                requestedAuthMethods: [],
                methodList: ['GRID_CARD', 'CASE_MOBILE', 'SMS', 'GEORGE_TOKEN'],
                submitingAuthKey: false,
                choosingMethod: false,
                leaveUrl: '',
                date: {
                    day: new Date().getDate(),
                    month: new Date().toLocaleDateString('sk', {month: 'long'}).replace(/[^ -~]/g, '').substring(0, 3).toUpperCase(),
                },
            }
        },

        computed: {
            modals() {
                return this.$parent.$refs.modals;
            },
        },

        components: {
            SignStripe,
            SignHeader
        },

        methods: {

            /**
             * Keep track of focused element.
             *
             * @param type - Flag signaling on or off state
             */
            handleFocus(type) {
                this.focus = (type) ? this.method : '';
            },

            /**
             * Un-pseudize method.
             *
             * @param method - Signing method
             * @returns Adjusted method
             */
            noPseudo(method) {
                return method.replace('$', '');
            },

            /**
             * Find if method is pseudo method.
             *
             * @param method - Signing method
             * @returns Flag if method is pseudo
             */
            isPseudo(method) {
                return method.slice(-1) === '$';
            },

            /**
             * Try to submit using enter button.
             */
            tryToSubmit() {
                if (this.focus === this.method) { this.submitAuthKey(); }
            },

            /**
             * Autofocus element after delay.
             *
             * @param selector - JQuery DOM selector
             */
            autoFocus(selector) {
                let interval;

                interval = setInterval(() => {

                    if ($(selector)[0]) {
                        let spree = setInterval(()=>{ $(selector)[0].focus(); }, 1);
                        setTimeout(()=>{ clearInterval(spree); }, 1000);
                        clearInterval(interval);
                    }

                }, 100);
            },

            /**
             * Build conditional leave URL.
             */
            prepareLeaveUrl() {
                let isSepa = !(this.$parent.trader.accredited);
                let vue = this;
                this.$parent.trader.leaveUrl = this.$parent.addUrlComponentsIfMissing(store.getters.getOne('url'));

                let params = {
                    u_predcislo: vue.$parent.payment.selectedAccount.accountPrefix,
                    u_cislo: vue.$parent.payment.selectedAccount.accountNumber,
                    u_kbanky: vue.$parent.slsp.bankCode,
                    pu_predcislo: store.getters.getOne('puPredcislo'),
                    pu_cislo: store.getters.getOne('puCislo'),
                    pu_kbanky: store.getters.getOne('puKbanky'),
                    suma: store.getters.getOne('suma'),
                    mena: store.getters.getOne('mena'),
                    url: encodeURIComponent(store.getters.getOne('url'))
                }

                // Sepa has different parameters than non-sepa.
                if (isSepa) {
                    params['end_to_end_id'] = store.getters.getOne('endToEndId');
                    params['recipient_message'] = store.getters.getOne('recipientMessage1');
                    params['recipient_message2'] = store.getters.getOne('recipientMessage2');
                    params['recipient_message3'] = store.getters.getOne('recipientMessage3');
                    params['recipient_message4'] = store.getters.getOne('recipientMessage4');
                }

                // Non sepa is easy af.
                else {
                    params['vs'] = store.getters.getOne('vs');
                    params['ss'] = store.getters.getOne('ss');
                }

                // Filter empty values and build final url.
                let paramPrefix = (store.getters.getOne('param') !== '') ? (store.getters.getOne('param') + '&param=' + encodeURIComponent(store.getters.getOne('param')) + '&') : '';
                this.$parent.trader.leaveUrl += paramPrefix + this.$helpers.parametrize(this.$helpers.filterKeys(params, ''));
            },

            /**
             * Disable background selection.
             */
            disableBackgroundSelection() {
                $(".select2-selection").attr("tabindex", "-1");
                $(".focusable:not(.in-modal)").attr("tabindex", "-1");
            },

            /**
             * Enable background selection.
             */
            enableBackgroundSelection() {
                $(".select2-selection").attr("tabindex", "0");
                $(".focusable:not(.in-modal)").attr("tabindex", "0");
            },

            /**
             * Show QR code.
             *
             * @returns Operation status
             */
            showQrCode() {
                if (!this.isMethodFamily('CASE_MOBILE')) { return false; }
                this.$parent.genericLogger('clicked on showing QR code', '');

                this.mTokenData.qrShown = true;
                const vue = this;

                const canvas = $('#qrCode')[0];
                const ctx = canvas.getContext('2d');

                // Store image so we don't need to re-generate it since it takes a while.
                if (this.mTokenData.image) {
                    ctx.drawImage(this.mTokenData.image, 0, 0, 250, 250);
                    return false;
                }

                var image = new Image();

                image.src = `data:image/png;base64,${this.mTokenData.challengeImage}`;
                image.onload = function() {
                    ctx.drawImage(image, 0, 0, 250, 250);
                    vue.mTokenData.image = image;
                }
            },

            /**
             * Checks if method is set or if it's pseudo form is used.
             *
             * @param method - Signing method
             * @returns Flag is string is in method family (e.g $SMS is in family with SMS)
             */
            isMethodFamily(method) {
                return this.method === method || (this.method.slice(0, -1) === method && this.method.slice(-1) === '$');
            },

            /**
             * Checks if pseudo method is curently being used.
             *
             * @returns Flag if pseudo method is set
             */
            pseudoMethodSet() {
                let ignores = ['NONE$'];

                if (ignores.indexOf(this.method) > -1) return false;

                return this.method.slice(-1) === '$';
            },

            /**
             * Engages signing process after clicking sign button.
             *
             * @param data - Signing data
             * @returns Operation status
             */
            engageSigning(data) {
                // Prepare leave URL base.
                this.prepareLeaveUrl();

                // Attempt to fetch signId.
                this.$api.getSignId(data.getId).then((response) => {

                    // Successful call.
                    if (!response.hasOwnProperty('error') && !response.hasOwnProperty('errors')) {

                        // Parse and save signId.
                        store.dispatch('setOne', { key: 'signId', value:response.transactionId });
                        this.signId = response.transactionId;
                        this.engageTimer();

                        // Fetch signing methods.
                        this.$api.signingStep1(this.signId).then((response) => {

                            // Successful call.
                            if (!response.hasOwnProperty('error') && !response.hasOwnProperty('errors')) {

                                // Trigger autofocus.
                                this.autoFocus('#text4697');

                                this.requestedAuthMethods = response.scenarios;

                                // Only one signing method is available.
                                if (response.scenarios.length <= 1) {
                                    this.changeMethod(response.scenarios[0][0]);
                                    return true;

                                } else {
                                    this.method = `${response.scenarios[0][0]}$`;
                                }

                                this.signingInitiated(() => true);

                            // Error has occured - like authorization limit exceeded.
                            } else {
                                let translation = { translate: 'generic' };
                                if (response.error === 'authLimitExceeded') {
                                    this.$parent.die('step1: authLimitExceeded', false, { translate: true, title: 'modals.authLimitExceeded.title', caption: 'modals.authLimitExceeded.caption' });
                                }
                                if (response.error === 'skOrderBlockedFps') {
                                    this.$parent.die('step1: skOrderBlockedFps', false, translation = { title: 'modals.skOrderBlockedFps.title', caption: 'modals.skOrderBlockedFps.caption', translate: true });
                                }
                                if (response.error === 'blockedFraud') {
                                    this.$parent.die('step1: blockedFraud', false, { title: 'modals.blockedFraud.title', caption: 'modals.blockedFraud.caption', translate: true });
                                } else {
                                    this.$parent.die('step1: generic', false, { translate: 'generic' });
                                }
                            }
                        });
                    } else {
                        let translation = { translate: 'generic' };
                        if (response.error === 'skOrderBlockedFps') {
                            this.$parent.die('getSignId: skOrderBlockedFps', true, { title: 'modals.skOrderBlockedFps.title', caption: 'modals.skOrderBlockedFps.caption', translate: true });
                        }
                        if (response.error === 'blockedFraud') {
                            this.$parent.die('getSignId: blockedFraud', true, { title: 'modals.blockedFraud.title', caption: 'modals.blockedFraud.caption', translate: true  });
                        } else {
                            this.$parent.die('getSignId: generic', true, { translate: 'generic' });
                        }
                    }
                });
            },

            /**
             * Start timer mapping sign ID validation period.
             */
            engageTimer() {
                clearInterval(this.timeService.clock);

                this.timeService.clock = setInterval(() => {
                    if (this.timeService.timer > 0) {
                        --this.timeService.timer;
                    } else {
                        if (this.timeService.timer === -.5) { return false; };
                        clearInterval(this.timeService.clock);
                        $('.keyMsg').html(this.$t('sign.smsKeyAckExpired'));
                        $('.keyMsg').attr('aria-live', 'assertive');
                    }
                }, 1000);
            },

            /**
             * Change signing method and switch screens.
             *
             * @param method - Signing method
             * @returns Operation status
             */
            changeMethod(method) {
                // Terminator - when we click on tab that is already selected.
                if (method === false || (this.isPseudo(method) && this.noPseudo(method) === this.method)) { return false ; }

                // Error message needs to be cleared when clicking tabs.
                this.errorMsg = {};

                this.method = method;

                // Pseudo methods are used to change UI if it has more screens, not perform requests (e.g SMS$).
                if (this.isPseudo(method)) {
                    this.$parent.genericLogger('signing method selected', method.replace('$', ''));
                    this.toolGenerated = {};
                    if (this.isMethodFamily(method)) { this.mTokenData.qrShown = false; }
                    return false;
                } else {
                    clearInterval(store.getters.getOne('mTokenRefresh'));
                }

                if (this.choosingMethod) { return false; }
                this.choosingMethod = true;

                this.$parent.genericLogger('signing method confirmed', method);

                this.$api.signingStep2(this.method).then((response) => {
                    // Attempt to switch method succeeded.
                    if (!response.hasOwnProperty('error') && !response.hasOwnProperty('errors')) {

                        this.choosingMethod = false;

                        this.timeService.timer = response['sk-validityTime'] || this.timeService.timer;
                        this.smsData.phoneNumber = response['sk-phoneNumber'] || this.smsData.phoneNumber;
                        this.smsData.smsId = response['sk-smsId'] || this.smsData.smsId;

                        // Adjust UI and conditions based on method.
                        // GRID card
                        if (method === 'GRID_CARD') {
                            this.gridData.placeholder += ` ${response.challengeCode}`;
                        }

                        // mToken
                        if ( (method === 'CASE_MOBILE' || method === "GEORGE_TOKEN") && (!this.toolGenerated['CASE_MOBILE'] || !this.toolGenerated['GEORGE_TOKEN']))  {
                            this.$api.mToken(response.poll, this);
                            this.mTokenData.challengeImage = response.challengeImage;
                        }

                        this.toolGenerated = {[method]: true}

                        this.signingInitiated(() => $("#sign").is(":visible") === false);

                    // Method could not be switched - you shall not pass.
                    } else {
                        if (response.error === 'noAuthAvailable') {
                            this.$parent.die('step2: noAuthAvailable', true, { translate: true, title: 'modals.noAuthAvailable.title', caption: 'modals.noAuthAvailable.caption' });
                        } else {
                            this.$parent.die('step2: generic', true, { translate: 'generic' });
                        }
                    }
                });
            },

            /**
             * Tell application that initial signing phase is finished.
             *
             * @param conditionEvaluator - Callback containing condition
             */
            signingInitiated(conditionEvaluator) {
                if (conditionEvaluator()) {
                    this.modals.show('sign');
                    this.$parent.genericLogger("sign modal displayed", "");
                }
                this.$parent.signing = false;
                document.body.style.opacity = 1;
                document.body.style.pointerEvents = 'auto';
            },

            /**
             * Force user out of our amazing application.
             *
             * @param after - Time in milliseconds
             */
            goodBye(after) {
                setTimeout(() => {
                    this.$parent.leaveAndInvalidate(true);
                }, after);
            },

            /**
             * Centrailzed set of calls after successful signing.
             */
            successfulSigningCallRoutine() {
                this.modals.hide('process');
                this.modals.hide('sign');

                this.modals.show('success', false, {
                    translate: 'generic'
                });
                this.$parent.genericLogger("success modal displayed", "");

                this.submitingAuthKey = false;
                this.goodBye(3000);
            },

            /**
             * Reset values of signing tools.
             */
            resetTools() {
                this.methodList.forEach((method) => {
                    this.toolGenerated[method] = false;
                });
            },

            /**
             * If signing window is closed, reset signing screen.
             */
            abortSigning() {
                this.modals.hide('sign');
                this.method = '';
                this.resetTools();
                this.errorMsg = {};
                this.mTokenData.qrShown = false;
                this.signId = '';
                this.GIRD_CARD = '';
                this.SMS = '';
                clearInterval(store.getters.getOne('mTokenRefresh'));
                this.$api.deleteSignRequest();
                this.gridData.placeholder = this.$t('sign.methods.gridPlaceholder');
                this.enableBackgroundSelection();
            },

            /**
             * Customized paymentCheck API call.
             */
            async paymentCheck() {
                // Show loader.
                this.modals.show('process', false, {translate: 'generic'});
                this.modals.hide('sign');

                // Check the payment after signing.
                const response = await this.$api.paymentCheck();

                // Successful call.
                if (!response.hasOwnProperty('error') && !response.hasOwnProperty('errors')) {
                    let prefix = this.$helpers.keyize(response, ['creditAccountIban', 'creditAccountBic', 'creditAccountName'], ['credit_acc_iban', 'credit_acc_bic', 'credit_acc_name']);
                    this.$parent.trader.leaveUrl += prefix + '&SIGN2=' + encodeURIComponent(response.sign2) + '&result=' + response.resultType + '&real=' + response.realizationResult;
                    this.successfulSigningCallRoutine();

                // Payment could not be verified - can not continue.
                } else {
                    this.$parent.die('payment check: generic', true, { translate: 'generic' });
                }
            },

            /**
             * Submit key to finish signing process.
             */
            async submitAuthKey() {
                // Display loading caption and hide signing part from signing screen.
                this.submitingAuthKey = true;
                this.$parent.genericLogger('clicked on submit auth key button', '');
                delete this.errorMsg[this.noPseudo(this.method)];

                const _method = this.noPseudo(this.method);

                // We're sending method and key.
                const data = JSON.stringify({
                    authorizationType: _method,
                    oneTimePassword: this.values[_method]
                });

                // Engage signing process.
                this.$api.signingStep3(data).then(async (response) => {

                    // Successful call.
                    if (!response.hasOwnProperty('error') && !response.hasOwnProperty('errors')) {

                        // Show loader.
                        this.modals.show('process', false, {translate: 'generic'});
                        this.modals.hide('sign');

                        // Check the payment after signing.
                        await this.paymentCheck();

                    // Terminal error (like too many tries, investigation or fraud).
                    } else if (
                        response.error !== 'otpInvalid'
                    ) {
                        // Check the payment after signing - https://jira.app.slsp.sk/browse/SDIT-34121
                        await this.paymentCheck();
                        // Different modal for each situation.
                        if (response.error === 'blockedInvestigation') {
                            this.$parent.die('step3: blockedInvestigation', false, { translate: true, title: `modals.blockedInvestigation.title`, caption: `modals.blockedInvestigation.caption`});
                        } else if (response.error === 'blockedFraud') {
                            this.$parent.die('step3: generic', false, { translate: true, title: `modals.blockedFraud.title`, caption: `modals.blockedFraud.caption`});
                        } else if (response.error === 'noAuthAvailable') {
                            this.$parent.die('step3: generic', false, { translate: true, title: `modals.noAuthAvailable.title`, caption: `modals.noAuthAvailable.caption`});
                        } else if (response.error === 'authLimitExceeded') {
                            this.$parent.die('step3: generic', false, { translate: true, title: `modals.authLimitExceeded.title`, caption: `modals.authLimitExceeded.caption`});
                        } else {
                            this.$parent.die('step3: generic', false, { translate: 'generic' });
                        }

                    // Incorrect OTP failed.
                    } else {
                        this.$parent.genericLogger('OTP invalid', '');
                        this.values.SMS = '';
                        this.values.GRID_CARD = '';
                        this.values.CASE_MOBILE = '';
                        this.values.GEORGE_TOKEN = '';
                        this.errorMsg[this.noPseudo(this.method)] = this.$t('sign.errors.wrongKeyError');
                        this.submitingAuthKey = false;
                        this.autoFocus('#text4697');

                        // We need to re-render the canvas.
                        if (this.isMethodFamily(_method)) {
                            this.$nextTick(this.showQrCode);
                        }
                    }
                });
            },
        },

        props: {
            type: {
                type: String,
                required: true
            },
            signData: {
                type: Object,
                required: true
            }
        }
    };

</script>

<style>
</style>
